import type { Video } from "#modules/optimization/media/video"
import type { PropsWithout } from "#types/utils"

import { useRef } from "react"

import { useLazyLoad } from "#modules/optimization/media/lazyload"
import { getVideoSrc } from "#modules/optimization/media/video"

/**
 * Lazy loaded video component that supports automatic source detection (next public dir, cms, devmode)
 */
export function LazyVideo(props: PropsWithout<typeof Video, "lazy">) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const src = getVideoSrc(props)

  useLazyLoad(videoRef, src)

  return <video {...props} src={undefined} data-src={src} ref={videoRef} />
}
